import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";

@Injectable()
export class PharmacyProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listPharmacies(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/pharmacies`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getPharmacy(program_id: string, pharmacyId: string) {
    return this.afs.collection<any>(`program/${program_id}/pharmacies/${pharmacyId}`);
  }

  addPharmacy(program_id: string, pharmacy: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    pharmacy = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...pharmacy };
    return this.afs.collection<any>(`program/${program_id}/pharmacies`).doc(doc_id).set(pharmacy);
  }

  updatePharmacy(program_id: string, pharmacy_id, pharmacy: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    pharmacy = { updatedAt, updatedBy, ...pharmacy };
    return this.afs.collection<any>(`program/${program_id}/pharmacies`).doc(pharmacy_id).update(pharmacy);
  }

  deletePharmacy(program_id: string, pharmacy_id: string)  {
    var batch = this.afs.firestore.batch();
    const docRef = this.afs.doc(`program/${program_id}/pharmacies/${pharmacy_id}`).ref;
    batch.delete(docRef);
    return batch.commit();
  }
}



// WEBPACK FOOTER //
// ./src/providers/pharmacy/pharmacy.ts